import React, { useEffect, useState } from "react";
import "./Home.css";
import Dashboard from "../DashBoard/DashBoard";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import MyProposals from "../MyProposals/MyProposals";
import AllProposals from "../AllProposals/AllProposals";
import { useLocation } from "react-router-dom";
import InternalDashboard from "../InternalDashboard/InternalDashboard";
import Admin from "../SystemAdmin/Admin";
import InternalManagement from "../InternalManagement/InternalManagement";
import { Globals } from "../../global/Globals";
import Requests from "../Requests/Requests";
import CryptoUtils from "../../util/cryptoUtils";
import AuditTrail from "../AuditTrail/AuditTrail";

const Home = () => {
  const location = useLocation();
  const { activeHeader } = location.state || '';
  const [selectedTab, setSelectedTab] = useState(activeHeader);
  console.log("activeheader",activeHeader);

  useEffect(() => {
    if (activeHeader) {
      handleTabClick(activeHeader);
    }
  }, [location.key]);

  useEffect(() => {
    const roleId = CryptoUtils.getFromLocalStorage("roleId")?.toString();
    if(activeHeader){
      setSelectedTab(activeHeader);
    }else{
      if (roleId === Globals.USER_ROLES.ADMIN) {
        setSelectedTab("admin");
      } else if (roleId === Globals.USER_ROLES.SNR_MGR || roleId === Globals.USER_ROLES.CC || roleId === Globals.USER_ROLES.CE || roleId ==="6") {
        setSelectedTab("internal_dashboard");
      } else if (roleId === Globals.USER_ROLES.PRODUCER) {
        setSelectedTab("dashboard");
      } 
    }
  }, []);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div className="home">
      <div className="Background-Page">
        <Header onTabClick={handleTabClick} route={selectedTab} />
        <div className="Main">
          <div class="dashboard_container">
          {selectedTab === "dashboard" && <Dashboard />}
          {selectedTab === "internal_dashboard" && <InternalDashboard />}
          {selectedTab === "admin" && <Admin selectedTab = {selectedTab}/>}
          {selectedTab === "proposals" && <MyProposals />}
          {selectedTab === "approvals" && <MyProposals />}
          {selectedTab === "all_proposals" && <AllProposals />}
          {selectedTab ==="requests" && <Requests />}
          {selectedTab ==="auditTrails" && <AuditTrail />}
          {selectedTab ==="internal_management" && <InternalManagement selectedTab = {selectedTab}/>}
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Home;
